/*
 * BeStable - Mengen-Bundle im Quick-Buy (Warenkorb-Cross-Sell).
 *
 * Der App-Block <bundle-selector data-bs-root> wird per ?view=quick-buy-drawer
 * bzw. ?view=quick-buy-popover ins Markup injiziert - aber ohne App-JS/CSS
 * (layout:false liefert kein <head>). Dieses theme-globale Skript initialisiert
 * den Block AUSSCHLIESSLICH innerhalb eines <quick-buy-drawer> ODER
 * <quick-buy-popover> und haengt ihn ans Formular: Klick auf "In den Warenkorb"
 * -> 1x-Variante der gewaehlten Farbe x gewaehlte Bundle-Menge (Rabatt via
 * Discount Function).
 *
 * Produktseite + App-eigenes bundle-selector.js bleiben voellig unberuehrt:
 * Scope strikt auf den Quick-Buy-Container (closest), eigener Ready-Guard.
 */
(function () {
  "use strict";

  var QB = "quick-buy-drawer, quick-buy-popover";

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function parseConfig(root) {
    var el = root.querySelector("script[data-bs-config]");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Farbe/Variante NUR aus dem Quick-Buy-Container lesen
  function selectedVariantId(scope) {
    var i = scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
            scope.querySelector('[name="id"]');
    return i && i.value ? String(i.value) : null;
  }
  function selectedColor(scope, cfg) {
    var vid = selectedVariantId(scope);
    if (vid && cfg.colorByVariant[vid] != null) return cfg.colorByVariant[vid];
    var opt = scope.querySelector('[name="option1"]:checked');
    if (opt && opt.value) return opt.value;
    return cfg.defaultColor;
  }
  // FIX 2026-07-31 (Groessen): gewaehlte Variante -> ihre 1x-Einheit aus
  // unitByVariant. FIX 2026-07-31b: Focals Master-Input [name=id] steht im
  // Quick-Buy-Fragment serverseitig DISABLED auf der Default-Variante und wird
  // bei Optionswechsel dort nicht zuverlaessig aktualisiert (product-form.liquid
  // Z. 588; Symptom: 34-38 gewaehlt -> 39-45 im Korb). Wahrheit sind die
  // OPTION-RADIOS/-SELECTS, die der Kunde direkt anklickt -> zuerst darueber
  // aufloesen (variantByOptions aus dem Block), erst danach die alte Kette
  // ([name=id] -> Farb-Map -> Default) fuer aeltere Block-HTML-Staende.
  function selectedByOptions(scope, cfg) {
    if (!cfg.variantByOptions) return null;
    var vals = [];
    for (var n = 1; n <= 3; n++) {
      var el = scope.querySelector('input[name="option' + n + '"]:checked') ||
               scope.querySelector('select[name="option' + n + '"]');
      if (!el || el.value == null || el.value === "") break;
      vals.push(el.value);
    }
    if (!vals.length) return null;
    var id = cfg.variantByOptions[vals.join("||")];
    return id != null ? String(id) : null;
  }
  function targetVariant(scope, cfg) {
    var ovid = selectedByOptions(scope, cfg);
    if (ovid) {
      if (cfg.unitByVariant && cfg.unitByVariant[ovid] != null) return cfg.unitByVariant[ovid];
      return ovid;
    }
    var vid = selectedVariantId(scope);
    if (vid && cfg.unitByVariant && cfg.unitByVariant[vid] != null) return cfg.unitByVariant[vid];
    var color = selectedColor(scope, cfg);
    var id = cfg.unitByColor ? cfg.unitByColor[color] : null;
    return id != null ? id : cfg.defaultUnit;
  }

  // Quick-Buy (Drawer ODER Popover) theme-nativ schliessen (ueber steuernden toggle-button)
  function closeQuickBuy(box) {
    if (!box || !box.id) return;
    var toggles = document.querySelectorAll('[aria-controls="' + box.id + '"][aria-expanded="true"]');
    if (toggles.length) { toggles.forEach(function (t) { try { t.click(); } catch (e) {} }); }
    else { box.removeAttribute("open"); }
  }

  function addAndOpen(variantId, qty, box) {
    return fetch(shopRoot() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(qty) || 1 }),
    }).then(function (res) {
      /* BE-STABLE (2026-08-21) B9-FIX: Shopifys Fehlergrund (description/message, kommt ueber den lokalisierten Pfad bereits in der Kundensprache) aus der 422/4xx-Antwort lesen statt ihn zu verschlucken - der Kunde erfaehrt z.B. "ausverkauft" statt nur einer generischen Meldung. */
      if (!res.ok) {
        return res.json().catch(function () { return null; }).then(function (errBody) {
          var bsMsg = (errBody && (errBody.description || errBody.message)) || "add failed";
          var bsErr = new Error(bsMsg);
          bsErr.bsShopifyReason = !!(errBody && (errBody.description || errBody.message));
          throw bsErr;
        });
      }
      return fetch(shopRoot() + "cart.js", { headers: { Accept: "application/json" } });
    }).then(function (r) { return r.json(); }).then(function (cart) {
      closeQuickBuy(box);
      var de = document.documentElement;
      de.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
      de.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
      var mini = document.querySelector("cart-drawer");
      if (mini) { mini.setAttribute("open", ""); }
    });
  }

  function initRoot(root) {
    if (root.__bsReady) return;
    var box = root.closest(QB);
    if (!box) return;                    // NUR im Quick-Buy (Drawer/Popover) aktiv
    var cfg = parseConfig(root);
    var form = box.querySelector('form[action*="/cart/add"]');
    if (!cfg || !form) return;           // noch nicht vollstaendig injiziert -> spaeter erneut
    root.__bsReady = true;
    root.__bsInit = true;                // App-JS-Guard, falls je mitgeladen

    // Spar-Praefixe kommen UEBERSETZT vom Server (data-bs-prefix/-active am Root) - synchron zum App-JS
    var pfx = root.getAttribute("data-bs-prefix") || "Spare";
    var pfxActive = root.getAttribute("data-bs-prefix-active") || "du sparst";
    var pills = root.querySelectorAll(".bs__pill");
    var marks = root.querySelectorAll(".bs__mark");
    var savetops = root.querySelectorAll("[data-bs-savetop]");
    var fill = root.querySelector("[data-bs-fill]");
    var qtyDisplay = root.querySelector("[data-bs-qty-display]");
    var count = pills.length || 1;

    marks.forEach(function (m) {
      var p = parseInt(m.getAttribute("data-bs-mark"), 10);
      m.style.left = ((p + 0.5) / count * 100) + "%";
    });

    // Startstufe (Nutzer 2026-07-30): im Warenkorb-Quick-Buy die 10er-Stufe vorwaehlen,
    // wenn das Produkt eine hat (Tape 1/5/10; Socken 1/3/6 seit 2026-10-20 mit 6er, s. u.).
    // Generisch ueber data-bs-qty="10" (Nutzerentscheid, robust gegen Varianten-/ID-Wechsel).
    // Gleicher Codepfad wie ein Pillen-Klick (updateUI unten) -> Haken, Balken, savetop und
    // Live-Preis oben konsistent; der Submit-Hook legt dann state.qty (=10) x 1x-Variante ein.
    // Produktseite bleibt unberuehrt: initRoot laeuft nur innerhalb quick-buy-drawer/popover.
    // BE-STABLE (2026-10-20, Nutzerwunsch): Socken (1/3/6) starten mit der 6er-Stufe.
    // Reihenfolge: 10er, wenn vorhanden (Tape), sonst 6er (Socken), sonst erste Stufe -
    // gleiche Regel wie auf der Produktseite (snippets/bs-bundle-preselect.liquid).
    var QB_PRESELECT_QTYS = ["10", "6"];
    var startPill = null;
    for (var qi = 0; qi < QB_PRESELECT_QTYS.length && !startPill; qi++) {
      for (var pi = 0; pi < pills.length; pi++) {
        if (pills[pi].getAttribute("data-bs-qty") === QB_PRESELECT_QTYS[qi]) { startPill = pills[pi]; break; }
      }
    }
    if (!startPill) startPill = pills[0] || null;
    var state = { qty: startPill ? startPill.getAttribute("data-bs-qty") : "1", sel: 0 };

    // Live-Preis im Quick-Buy (Nutzer 2026-07-03, wie Produktseite): gewaehlte Stufe
    // -> Preis oben im Drawer/Popover rot + durchgestrichen + "(Du sparst X)"-Label;
    // Einzelstufe = Original zurueck. Preise fertig formatiert aus data-bs-total/-compare/-save.
    var qbPl = box.querySelector("[data-product-price-list]");
    var qbPlOrig = qbPl ? qbPl.innerHTML : null;
    var qbApplying = false;

    function syncQbPrice() {
      var pl = box.querySelector("[data-product-price-list]");
      if (!pl) return;
      var pill = root.querySelector('.bs__pill[data-bs-i="' + state.sel + '"]');
      if (!pill) return;
      var total = pill.getAttribute("data-bs-total") || "";
      var compare = (pill.getAttribute("data-bs-compare") || "").trim();
      var save = (pill.getAttribute("data-bs-save") || "").trim();
      qbApplying = true;
      try {
        if (!compare || !total) {
          if (qbPlOrig != null && pl.innerHTML !== qbPlOrig) pl.innerHTML = qbPlOrig;
        } else {
          var vh = pl.querySelector(".visually-hidden");
          var hidden = vh ? '<span class="visually-hidden">' + vh.textContent + "</span>" : "";
          var word = pfxActive.charAt(0).toUpperCase() + pfxActive.slice(1);
          pl.innerHTML =
            '<span class="price price--highlight">' + hidden + total + "</span> " +
            '<span class="price price--compare">' + compare + "</span>" +
            (save ? ' <span class="label label--highlight">(' + word + " <span class='ed-save-amount'>" + save + "</span>)</span>" : "");
        }
      } finally {
        setTimeout(function () { qbApplying = false; }, 0);
      }
    }

    // Focal rendert die Quick-Buy-Meta bei Farbwechsel neu -> Stufe erneut anwenden
    var qbMeta = box.querySelector("product-meta");
    if (qbMeta && qbPl) {
      new MutationObserver(function () {
        if (qbApplying) return;
        var pill = root.querySelector('.bs__pill[data-bs-i="' + state.sel + '"]');
        if (pill && (pill.getAttribute("data-bs-compare") || "").trim()) syncQbPrice();
      }).observe(qbMeta, { childList: true, subtree: true });
    }

    function updateUI(sel, qty) {
      state.sel = sel;
      pills.forEach(function (pl) {
        pl.classList.toggle("is-selected", pl.getAttribute("data-bs-i") === String(sel));
      });
      if (qtyDisplay) qtyDisplay.textContent = qty;
      if (fill) fill.style.width = ((sel + 1) / count * 100) + "%";
      marks.forEach(function (m) {
        var p = parseInt(m.getAttribute("data-bs-mark"), 10);
        m.classList.remove("is-up", "is-down");
        if (sel === p) m.classList.add("is-up");
        else if (sel < p) m.classList.add("is-down");
      });
      // Savetop KOMPLETT gruen wenn aktiv (Nutzer-Korrektur 2026-07-03: Wort-Split
      // gilt nur fuer das "(Du sparst X)"-Label, NICHT fuer diese Zeile).
      savetops.forEach(function (s) {
        var p = parseInt(s.getAttribute("data-bs-savetop"), 10);
        if (sel > p) {
          s.style.visibility = "hidden";
        } else {
          s.style.visibility = "visible";
          s.textContent = (sel === p ? pfxActive + " " : pfx + " ") + (s.dataset.bsEur || "");
          s.classList.toggle("is-active", sel === p);
        }
      });
      syncQbPrice();
    }

    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        state.qty = pill.getAttribute("data-bs-qty");
        updateUI(parseInt(pill.getAttribute("data-bs-i"), 10), state.qty);
      });
    });
    if (startPill) updateUI(parseInt(startPill.getAttribute("data-bs-i"), 10), state.qty);

    if (!form.__bsHook) {
      form.__bsHook = true;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        /* BE-STABLE (2026-10-09) Audit Nr. 10: Doppelklick legte die Menge doppelt in den Warenkorb (10er-Tape wurde 20).
           Waehrend eine Anfrage laeuft, wird jedes weitere Absenden ignoriert; der Knopf zeigt den Ladekreis (loader-button)
           und ist gesperrt, bis die Anfrage fertig ist - auch im Fehlerfall. (Zusaetzlich sperrt bs-cart-guards global.) */
        if (form.__bsBusy) return;
        var vid = targetVariant(box, cfg);
        if (!vid) return;
        form.__bsBusy = true;
        /* nur Knoepfe, die gerade aktiv sind - ausverkaufte (serverseitig disabled) bleiben unberuehrt */
        var btns = Array.prototype.filter.call(form.querySelectorAll('button[type="submit"]'), function (b) { return !b.disabled; });
        btns.forEach(function (b) { b.disabled = true; b.setAttribute("aria-busy", "true"); });
        var frei = function () {
          form.__bsBusy = false;
          btns.forEach(function (b) { b.disabled = false; b.removeAttribute("aria-busy"); });
        };
        addAndOpen(vid, state.qty, box).then(frei, function (err) {
          frei();
          console.error("[BeStable QuickBuy Bundle]", err);
          /* BE-STABLE (2026-08-21) B9-FIX: Shopifys (lokalisierten) Grund anhaengen, wenn vorhanden. */
          /* BE-STABLE (2026-10-16) N4: Meldung aus der Sprachdatei (cart.general.bs_add_error), deutscher Text nur als Rueckfall */
          var bsStr = window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.bsQuickBuyAddError;
          var bsBase = bsStr || "Konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.";
          alert(err && err.bsShopifyReason && err.message ? bsBase + "\n\n" + err.message : bsBase);
        });
      }, true);
    }
  }

  function scan() {
    document.querySelectorAll("quick-buy-drawer [data-bs-root], quick-buy-popover [data-bs-root]").forEach(initRoot);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; scan(); }, 0);
  }

  if (document.readyState !== "loading") schedule();
  document.addEventListener("DOMContentLoaded", schedule);
  document.addEventListener("cart:refresh", schedule);

  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/*
 * BeStable - Set-Selector -> Live-Preis oben (Schoner-Produktseiten, 2026-07-03).
 * Solo/Duo/Trio-Klick aktualisiert die Focal-Preisliste in der product-meta:
 * Endpreis rot + durchgestrichener Originalpreis + gruenes "(Du sparst X)"-Label
 * (Optik wie collection.product.discount_html). Solo = Original-Markup zurueck.
 * Preise/Betraege kommen fertig formatiert aus dem edss-DOM (.edss__now/.edss__was/
 * .edss-fl__save) - kein Rechnen, marktwaehrungssicher. Wort je Sprache wie im
 * Mengen-Bundler (bundle_selector.save).
 */
(function () {
  "use strict";
  var WORDS = { de: "Du sparst", en: "Save", es: "Ahorra", fr: "Économise", it: "Risparmia", nl: "Bespaar", pl: "Oszczędź", sv: "Spara" };

  function init() {
    var edss = document.querySelector(".product__info .edss");
    var pl = document.querySelector(".product-meta [data-product-price-list]");
    if (!edss || !pl || edss.__bsTopPrice) return;
    edss.__bsTopPrice = true;

    var ll = document.querySelector(".product-meta [data-product-label-list]");
    var priceOrig = pl.innerHTML;
    var labelOrig = ll ? ll.innerHTML : "";
    var loc = ((window.Shopify && window.Shopify.locale) || "de").slice(0, 2);
    var word = WORDS[loc] || WORDS.de;
    var applying = false;

    function apply() {
      if (applying) return;
      var sel = edss.querySelector(".edss__tier.is-selected");
      if (!sel) return;
      var now = sel.querySelector(".edss__now");
      var was = sel.querySelector(".edss__was");
      applying = true;
      try {
        pl = document.querySelector(".product-meta [data-product-price-list]") || pl;
        ll = document.querySelector(".product-meta [data-product-label-list]") || ll;
        if (!now || !was) {
          // Solo: Original-Markup zurueck
          if (pl.innerHTML !== priceOrig) pl.innerHTML = priceOrig;
          if (ll && ll.innerHTML !== labelOrig) ll.innerHTML = labelOrig;
        } else {
          var vh = pl.querySelector(".visually-hidden");
          var hidden = vh ? '<span class="visually-hidden">' + vh.textContent + "</span>" : "";
          pl.innerHTML =
            '<span class="price price--large price--highlight">' + hidden + now.textContent.trim() + "</span> " +
            '<span class="price price--compare">' + was.textContent.trim() + "</span>";
          if (ll) {
            var saveEl = sel.querySelector(".edss-fl__save");
            var m = saveEl ? saveEl.textContent.trim().match(/\d.*$/) : null;
            var amt = m ? m[0].trim() : "";
            ll.innerHTML = labelOrig + (amt
              ? '<span class="label label--highlight">(' + word + " <span class='ed-save-amount'>" + amt + "</span>)</span>"
              : "");
          }
        }
      } finally {
        setTimeout(function () { applying = false; }, 0);
      }
    }

    // Tier-Wechsel (is-selected) beobachten + Focal-Preis-Rerender (Farbwechsel) abfangen
    new MutationObserver(apply).observe(edss, { subtree: true, attributes: true, attributeFilter: ["class"] });
    var meta = document.querySelector(".product-meta");
    if (meta) new MutationObserver(apply).observe(meta, { childList: true, subtree: true });
    apply();
  }

  if (document.readyState !== "loading") init();
  document.addEventListener("DOMContentLoaded", init);
})();

/*
 * BeStable - Zepto-Flow-Texte uebersetzen (2026-07-03, Nutzerauftrag: NUR die drei
 * Pflichtfeld-Texte aus den Zepto "Add to Cart Settings"). Zepto kann keine Mehr-
 * sprachigkeit - die Texte stehen einsprachig (deutsch) in der App-Konfiguration.
 * Dieses Skript ersetzt sie NUR innerhalb von Zepto-Containern ([class*="pplr"]),
 * nur bei EXAKTEM Treffer und nur auf Nicht-DE-Seiten. Idempotent (ersetzter Text
 * matcht nicht erneut -> keine Observer-Schleife). ACHTUNG: Aendert der Shop die
 * Texte in den Zepto-Settings, muss dieses Woerterbuch nachgezogen werden.
 */
(function () {
  "use strict";
  var loc = ((window.Shopify && window.Shopify.locale) || "de").slice(0, 2);
  if (loc === "de") return;
  var DICT = {
    "lädt": { en: "Loading", es: "Cargando", fr: "Chargement", it: "Caricamento", nl: "Laden", pl: "Ładowanie", sv: "Laddar" },
    "in Warenkorb legen": { en: "Adding to cart", es: "Añadiendo al carrito", fr: "Ajout au panier", it: "Aggiunta al carrello", nl: "Toevoegen aan winkelwagen", pl: "Dodawanie do koszyka", sv: "Lägger i varukorgen" },
    "ihr Artikel liegt nun im Warenkorb": { en: "Your item is now in the cart", es: "Tu artículo ya está en el carrito", fr: "Ton article est maintenant dans le panier", it: "Il tuo articolo è ora nel carrello", nl: "Je artikel zit nu in de winkelwagen", pl: "Twój artykuł jest teraz w koszyku", sv: "Din vara ligger nu i varukorgen" },
    "Foto L": { en: "Photo left", es: "Foto izquierda", fr: "Photo gauche", it: "Foto sinistra", nl: "Foto links", pl: "Lewe zdjęcie", sv: "Vänster foto" },
    "Foto R": { en: "Photo right", es: "Foto derecha", fr: "Photo droite", it: "Foto destra", nl: "Foto rechts", pl: "Prawe zdjęcie", sv: "Höger foto" }
  };

  function translateIn(root) {
    var containers = root.querySelectorAll ? root.querySelectorAll('[class*="pplr"]') : [];
    for (var i = 0; i < containers.length; i++) {
      var walker = document.createTreeWalker(containers[i], NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        var t = n.textContent.trim();
        if (DICT[t] && DICT[t][loc]) {
          n.textContent = n.textContent.replace(t, DICT[t][loc]);
          continue;
        }
        // "Foto L 16cm" u. ae.: Groessen-/Zusatzangaben hinter dem Label mitnehmen
        // (Basis uebersetzen, Zusatz unveraendert anhaengen).
        var m = t.match(/^(Foto [LR])(\s+.+)$/);
        if (m && DICT[m[1]] && DICT[m[1]][loc]) {
          n.textContent = n.textContent.replace(t, DICT[m[1]][loc] + m[2]);
        }
      }
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; translateIn(document); }, 60);
  }

  if (document.readyState !== "loading") schedule();
  document.addEventListener("DOMContentLoaded", schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
